import React, { useEffect, useRef, useState } from 'react';

const FooterMap = () => {
  const mapRef = useRef(null);
  const [showMap, setShowMap] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShowMap(true);
          observer.disconnect();
        }
      },
      { rootMargin: '200px' } // Load slightly before it appears
    );

    if (mapRef.current) observer.observe(mapRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={mapRef} className="mapContainer">
      {showMap && (
        <iframe
          title="West Virginia Google Maps"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3808985.513846705!2d-81.53526767221462!3d38.82031962759739!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x884a54a5d4cb0945%3A0xbb00c768decd3a43!2sWest%20Virginia!5e1!3m2!1sen!2sus!4v1741503591211!5m2!1sen!2sus"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      )}
    </div>
  );
};

export default FooterMap;
